import React, { useState } from 'react';
import { TagIcon, Squares2X2Icon, Cog6ToothIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import CommonPageHeader from '../common/CommonPageHeader';
import CategoryManager from './CategoryManager';
import FeatureManager from './FeatureManager';
import ExtraManager from './ExtraManager';

type Tab = 'categories' | 'features' | 'extras';

const VehicleSettings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('categories');

  return (
    <div className="space-y-6">
      <CommonPageHeader
        title="Járműbeállítások"
        subtitle="Kategóriák és jellemzők kezelése a flexie-car weboldalhoz"
        icon={Cog6ToothIcon}
      />

      {/* Tabs */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="border-b border-gray-200 dark:border-gray-700">
          <nav className="-mb-px flex space-x-8 px-6">
            <button
              onClick={() => setActiveTab('categories')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2
                ${activeTab === 'categories'
                  ? 'border-primary-500 text-primary-600 dark:text-primary-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                }
              `}
            >
              <Squares2X2Icon className="h-5 w-5" />
              Kategóriák
            </button>
            <button
              onClick={() => setActiveTab('features')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2
                ${activeTab === 'features'
                  ? 'border-primary-500 text-primary-600 dark:text-primary-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                }
              `}
            >
              <TagIcon className="h-5 w-5" />
              Jellemzők
            </button>
            <button
              onClick={() => setActiveTab('extras')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2
                ${activeTab === 'extras'
                  ? 'border-primary-500 text-primary-600 dark:text-primary-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                }
              `}
            >
              <PlusCircleIcon className="h-5 w-5" />
              Extrák
            </button>
          </nav>
        </div>

        {/* Content */}
        <div className="p-6">
          {activeTab === 'categories' && <CategoryManager />}
          {activeTab === 'features' && <FeatureManager />}
          {activeTab === 'extras' && <ExtraManager />}
        </div>
      </div>
    </div>
  );
};

export default VehicleSettings;
